import axios from 'axios'
import qs from 'qs'
import JSEncrypt from 'jsencrypt';
let Base64 = require("js-base64").Base64;

axios.defaults.timeout = 500000; //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.baseURL = '';
const HTTP = {};

HTTP.setToken = function (token) {
    axios.defaults.headers.post['token'] = token;
    axios.defaults.headers.get['token'] = token;
}

HTTP.get = function (url, params, parseResult = true) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            headers: {
                "Zw-Type": "ajax/json",
            }
            , params
        }).then(response => {
            let result = response.data
            if (parseResult) {
                if (response.status === 200) {
                    resolve(result.content)
                } else {
                    reject(result.content)
                }
            } else {
                resolve(result)
            }
        },
            err => {
                reject(err)
            }
        )
            .catch(error => {
                reject(error)
            })
    })
}

HTTP.post = function (url, params, parseResult = true) {
    if (params) {
        let base = ''

        for (let key in params) {
            base += key + '=' + params[key] + '&'
        }
        base = base.substr(0, base.length - 1);
        var pubKey = window.sessionStorage.getItem('trip')
        var encryptStr = new JSEncrypt();
        encryptStr.setPublicKey(pubKey); // 设置 加密公钥
        var datas = encryptStr.encrypt(base);  // 进行加密
    }
    else {
        var datas = params
    }

    //        params = Base64.encode(datas);
    return new Promise((resolve, reject) => {
        axios.post(url, datas, {
            headers: {
                "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
            }
        })
            .then(
                response => {
                    let result = response.data
                    if (parseResult) {
                        if (response.status === 200) {
                            resolve(result.content)
                        } else {
                            reject(result);
                        }
                    } else {
                        resolve(result)
                    }
                },
                err => {
                    reject(err)
                }
            )
            .catch(error => {
                reject(error)
            })
    })
},
    HTTP.patch = function (url, params, parseResult = true) {
        if (params) {
            let base = ''

            for (let key in params) {
                base += key + '=' + params[key] + '&'
            }
            base = base.substr(0, base.length - 1);
            var pubKey = window.sessionStorage.getItem('trip')
            var encryptStr = new JSEncrypt();
            encryptStr.setPublicKey(pubKey); // 设置 加密公钥
            var datas = encryptStr.encrypt(base);  // 进行加密
        }
        else {
            var datas = params
        }

        //        params = Base64.encode(datas);
        return new Promise((resolve, reject) => {
            axios.patch(url, datas, {
                headers: {
                    "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
                }
            })
                .then(
                    response => {
                        let result = response.data
                        if (parseResult) {
                            if (response.status === 200) {
                                resolve(result.content)
                            } else {
                                reject(result);
                            }
                        } else {
                            resolve(result)
                        }
                    },
                    err => {
                        reject(err)
                    }
                )
                .catch(error => {
                    reject(error)
                })
        })
    },
    HTTP.patchJson = function (url, params, parseResult = true) {
        if (params) {
            let param = JSON.stringify(params)
            var pubKey = window.sessionStorage.getItem('trip')
            var encryptStr = new JSEncrypt();
            encryptStr.setPublicKey(pubKey); // 设置 加密公钥
            var datas = encryptStr.encrypt(param);  // 进行加密
        }
        else {
            var datas = params
        }
        return new Promise((resolve, reject) => {
            axios.patch(url, datas, {
                headers: {
                    "content-type": "application/json",
                }
            })
                .then(
                    response => {
                        let result = response.data
                        if (parseResult) {
                            if (response.status === 200) {
                                resolve(result.content)
                            } else {
                                reject(result);
                            }
                        } else {
                            resolve(result)
                        }
                    },
                    err => {
                        reject(err)
                    }
                )
                .catch(error => {
                    reject(error)
                })
        })
    },


    HTTP.postFormData = function (url, params, parseResult = true) {
        return new Promise((resolve, reject) => {
            axios.post(url, params, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(response => {
                    let result = response.data;

                    if (parseResult) {
                        if (result.code === 0) {
                            resolve(result.message);
                        } else {
                            reject(result)
                        }
                    } else {
                        resolve(result);
                    }
                }, err => {
                    reject(err);
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
HTTP.postJson = function (url, params, json, parseResult = true) {

    return new Promise((resolve, reject) => {
        axios.post(url + '?' + qs.stringify(params), json).then(response => {
            let result = response.data;
            if (parseResult) {
                if (result.code === 0) {
                    resolve(result.message);
                } else {
                    reject(result)
                }
            } else {
                resolve(result)
            }
        }, err => {
            reject(err);
        })
            .catch((error) => {
                reject(error)
            })
    })
}
HTTP.json = function (url, params, parseResult = true) {

    if (params) {
        let param = JSON.stringify(params)

        var pubKey = window.sessionStorage.getItem('trip')
        var encryptStr = new JSEncrypt();
        encryptStr.setPublicKey(pubKey); // 设置 加密公钥
        var data = encryptStr.encrypt(param);  // 进行加密
    }
    else {
        var data = params
    }

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: url,
            baseURL: url,
            headers: { 'Content-Type': 'application/json;charset=UTF-8' },
            data: data
        })
            .then(
                response => {
                    let result = response.data
                    if (parseResult) {
                        if (response.status === 200) {
                            resolve(result.content)
                        } else {
                            reject(result);
                        }
                    } else {
                        resolve(result)
                    }
                },
                err => {
                    reject(err)
                }
            )
            .catch(error => {
                reject(error)
            })
    })
}
HTTP.delete = function (url, params, parseResult = true) {
    return new Promise((resolve, reject) => {
        axios.delete(url + '?' + qs.stringify(params), {
            headers: {
            }
        })
            .then(
                response => {
                    let result = response.data
                    if (parseResult) {
                        if (response.status === 200) {
                            resolve(result.content)
                        } else {
                            reject(result);
                        }
                    } else {
                        resolve(result)
                    }
                },
                err => {
                    reject(err)
                }
            )
            .catch(error => {
                reject(error)
            })
    })
}
HTTP.put = function (url, params, parseResult = true) {
    if (params) {
        let base = ''
        for (let key in params) {
            base += key + '=' + params[key] + '&'
        }
        base = base.substr(0, base.length - 1);
        var pubKey = window.sessionStorage.getItem('trip')
        var encryptStr = new JSEncrypt();
        encryptStr.setPublicKey(pubKey); // 设置 加密公钥
        var datas = encryptStr.encrypt(base);  // 进行加密
    }
    else {
        var datas = params
    }
    return new Promise((resolve, reject) => {
        axios.put(url, datas, {
            headers: {
                "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
            }
        })
            .then(
                response => {
                    let result = response.data
                    if (parseResult) {
                        if (response.status === 200) {
                            resolve(result.content)
                        } else {
                            reject(result);
                        }
                    } else {
                        resolve(result)
                    }
                },
                err => {
                    reject(err)
                }
            )
            .catch(error => {
                reject(error)
            })
    })
}


export default HTTP